import { render, staticRenderFns } from "./ChatsFilterDetail.vue?vue&type=template&id=ffb4f746&"
import script from "./ChatsFilterDetail.vue?vue&type=script&lang=js&"
export * from "./ChatsFilterDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports